import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GridWrapper, GridRow, GridColumn, Heading, Text } from 'react-onei';

import UserContext from "../../context/UserContext";

const Head = () => {
  let location = useLocation();
  const { identities, wording } = useContext(UserContext);
  const { login } = identities;
  const { WLOST_001, WLOST_002, WLOST_006 } = wording;
  const [title, setTitle] = useState(WLOST_001);
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    switch (location.pathname) {
      case '/letter':
      case '/letter/pending':
        setTitle(WLOST_002);
        break;
      case '/letter/confirm':
      case '/confirm':
      case '/error':
        setDisplay(false);
        break;
      case '/contact':
        setTitle(WLOST_006);
        break;
      default:
        setTitle(WLOST_001);
        setDisplay(true);
        break;
    }
  }, [WLOST_001, WLOST_002, WLOST_006, location]);

  if (display) {
    return (
      <GridWrapper>
        <GridRow>
          <GridColumn>
            <Heading as="h1" id="app-title" className="spacing-s">
              {title}
            </Heading>
            {login && (
              <Text variant="lead" id="user-login">
                <strong>
                  {login}
                </strong>
              </Text>
            )}
          </GridColumn>
        </GridRow>
      </GridWrapper>
    )
  } else {
    return null;
  }
}

export default Head;
